import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { put, takeEvery } from 'redux-saga/effects';

import { createErrorAction } from '../../actions/error';
import { notificationShown, NotificationShownActionType, notificationShownUpdated } from '../../actions/notification/notificationShown';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* notificationShownSaga({ payload }: NotificationShownActionType) {
  const { uuid } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.notificationWasShown, token, {
    notificationUuid: uuid,
  });
  const { error } = response;
  if (!error) {
    const responseAction = notificationShownUpdated({ uuid });
    yield put(responseAction);
  } else {
    yield put(createErrorAction({ errorMessage: error }));
  }
}

export default function* watchNotificationShownSaga() {
  yield takeEvery(notificationShown, notificationShownSaga);
}
